// extracted by mini-css-extract-plugin
module.exports = {"d1j4f7ek":"d1j4f7ek"};